import type React from "react";
import { useState } from "react";
import { motion } from "framer-motion";

import { HeroForm } from "../../Hero/HeroForm";
import clsx from "clsx";
import { appStore } from "store";
import { PresaleTop } from "./PresalaCardTopPart";
import { useLocation } from "react-router-dom";
import {
  AnimatedGradientBorder,
  GlowCard,
} from "screens/Landing/components/shared";

interface PresaleCardProps {
  /** Fallback when `currentRound.finishAt` is missing */
  targetDate?: string;
}

export const DashboarBuyForm: React.FC<PresaleCardProps> = ({
  targetDate = "2024-12-31T23:59:59",
}) => {
  const [isStartPayment, setIsStartPayment] = useState(false);
  const { currentRound } = appStore();
  const location = useLocation();
  const pathname = location.pathname;

  const isDashboard = pathname === "/dashboard";

  const cardAnimation = {
    initial: { opacity: 0, y: "20px", scale: 0.95 },
    animate: { opacity: 1, y: 0, scale: 1 },
    transition: { duration: 0.8, ease: "easeOut" },
  };

  return (
    <>
      <motion.div
        {...cardAnimation}
        className="flex relative z-20  max-lg:mb-[64px] flex-col gap-[16px] max-lg:gap-[16px] w-full max-lg:w-full lg:max-w-[445px] "
      >
        <AnimatedGradientBorder className="rounded-[28px] max-lg:rounded-[28px]">
          <GlowCard
            className={clsx(
              "rounded-[28px] max-lg:rounded-[28px]",
              !isStartPayment &&
                "flex flex-col gap-[15px] bg-[#111111] w-[445px] max-lg:w-full p-[12px] max-lg:p-[12px]",
              isDashboard
                ? "max-lg:gap-[6px] max-lg:justify-between sm:min-h-auto"
                : "max-lg:gap-[15px]",
            )}
          >
            {!isStartPayment && (
              <PresaleTop
                iResponsible={isDashboard}
                targetDate={targetDate}
                currentRound={currentRound}
                hideUsdRaised={false}
              />
            )}

            <HeroForm
              isStartPayment={isStartPayment}
              setIsStartPayment={setIsStartPayment}
            />
          </GlowCard>
        </AnimatedGradientBorder>
      </motion.div>
    </>
  );
};
